import { SET_SIGNIN_NAV_HEADER } from "../actions/all_action"

export const initialState = {
    nav_header: ""
}

export const signInReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SIGNIN_NAV_HEADER:
            return {
                ...state,
                nav_header: action.payload.header_text
            }
        default:
            return state;
    }
}